import React, { FC, useState, useEffect, memo } from "../../../../lib/teact/teact";
import ConfirmDialog from "../../../ui/ConfirmDialog";

type OwnProps = {
    dataTrung: any[];
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (idListTinTrungNhau: number[]) => void;
}

const DialogTinTrungNhau: FC<OwnProps> = ({
    dataTrung,
    isOpen,
    onClose,
    onConfirm
}) => {
    function handleConfirm() {
        const idListTinTrungNhau = dataTrung.map(msg => msg.messageId);
        onConfirm(idListTinTrungNhau);       
        onClose();
    }
    function handleCancel() {        
        onClose();
    }
    return <ConfirmDialog isOpen={isOpen}
        confirmHandler={() => { handleConfirm() }}
        onClose={handleCancel}
        title="Tin có nội dung trùng nhau"
        confirmLabel="Hiển thị"
    >
        <div className="common-container-col" style='gap:10px;'>
            {
                dataTrung.map(msg => {
                    return <div className="message-body">{msg.body}</div>
                })
            }
        </div>
    </ConfirmDialog>
}

export default memo(DialogTinTrungNhau);